function createSnow() {
  const snow = document.getElementById("snow");

  let snowflake = document.createElement("div");
  snowflake.className = "snowflake";
  snowflake.innerHTML = "•";

  // Slow movement
  snowflake.style.left = Math.random() * 100 + "vw";
  snowflake.style.animationDuration = 10 + Math.random() * 8 + "s"; 
  snowflake.style.fontSize = 10 + Math.random() * 10 + "px";

  snow.appendChild(snowflake);

  setTimeout(() => snowflake.remove(), 20000);
}

setInterval(createSnow, 1500);
createSnow();
